__turbopack_context__.v({
  "projects-main": "page-module-sass-module__ZHI-SG__projects-main",
  "projects-title": "page-module-sass-module__ZHI-SG__projects-title",
});
